export default __webpack_public_path__ + "static/media/classroom.e822937c.png";